import React, { Suspense } from 'react';
import { RouteObject } from 'react-router';
import PageSkeleton from '@/modules/ui/skeleton/PageSkeleton';

const PublicUploadPage = React.lazy(
  () => import('@/modules/public-incidence-upload/components/PublicUploadPage'),
);
export const publicChildren: RouteObject[] = [
  {
    path: 'incidence-upload/:token',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <PublicUploadPage />
      </Suspense>
    ),
  },
];
